import React, { useMemo } from "react"

import { Controller } from 'react-hook-form'

import { bool, object } from "prop-types"

import { useRole } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'
import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'
import CustomSelect from "Pods/Shared/CustomSelect/CustomSelect"

import { MATERIAL_OPTIONS, PRINT_RESULT_OPTIONS, translateOptions } from "../../../../Utils/Data"

function MaterialAndResultForm({
  control,
  userHavePermissions,
}) {
  const role = useRole()
  const { t } = useUseCaseTranslate()
  const materialOptions = useMemo(() => translateOptions(MATERIAL_OPTIONS, 'material', t), [t])
  const printResultOptions = useMemo(() => translateOptions(PRINT_RESULT_OPTIONS, 'printResult', t), [t])

  return (
    <>
      <div className="use-cases-area__select-container use-cases-area__form-column">
        <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
          {t('form.materialLabel')}
        </span>
        <Controller
          name="material"
          control={control}
          render={({ field }) => (
            <CustomSelect
              {...field}
              options={materialOptions}
              placeholder={t('form.materialPlaceholder')}
              isDisabled={!userHavePermissions}
              className="use-cases-area__select cgt-body-base-semibold"
              isClearable
            />
          )}
        />
      </div>

      {role !== 'seller' && (
        <div
          className="use-cases-area__select-container use-cases-area__form-column"
          style={{ flexBasis: '100%' }}
        >
          <span className="use-cases-area__label cgt-body-base-semibold cgt-mb-4">
            {t('form.printResultLabel')}
          </span>
          <Controller
            name="printSuccess"
            control={control}
            render={({ field }) => (
              <CustomSelect
                {...field}
                options={printResultOptions}
                placeholder={t('form.printResultPlaceholder')}
                isDisabled={!userHavePermissions}
                className="use-cases-area__select cgt-body-base-semibold"
                isClearable={false}
              />
            )}
          />
        </div>
      )}
    </>
  )
}

MaterialAndResultForm.propTypes = {
  control: object.isRequired,
  userHavePermissions: bool.isRequired,
}

export default MaterialAndResultForm
